export default class Store {
  constructor({
    tableName,
    DBName
  }) {
    this.TABLE = tableName;
    this.DBName = DBName;
  }
  async clear(){
    const db = await this.getDB();
    const transaction = db.transaction(this.TABLE, 'readwrite');
    const store = transaction.objectStore(this.TABLE);
    store.clear();
   
    transaction.oncomplete = function() {
      db.close();
    };
  }
  async save(data) {
    // 打开 IndexedDB 数据库
    const db = await this.getDB();

    // 在事务中存储数据
    const transaction = db.transaction(this.TABLE, 'readwrite');
    const store = transaction.objectStore(this.TABLE);
    const addRequest = store.add(data);

    addRequest.onerror = function(event) {
      console.error('数据存储失败', event.target.error);
    };

    transaction.oncomplete = function() {
      db.close();
    };
  }
  getDB() {
    const tableName = this.TABLE;
    const DBName = this.DBName;
    return new Promise((resolve, reject) => {
      // 打开 IndexedDB 数据库
      const request = indexedDB.open(DBName, 1);
  
      request.onerror = (event) =>{
        console.error('打开数据库失败', event.target.error);
        reject(event);
      };
      request.onupgradeneeded = function(event) {
        console.log('创建对象存储空间', tableName);
        const db = event.target.result;
  
        // 创建对象存储空间
        db.createObjectStore(tableName, { autoIncrement: true });
      };
  
      request.onsuccess = function(event) {
        const db = event.target.result;
        try {
          db.createObjectStore(tableName, { autoIncrement: true });
        } catch (err) {
          console.log(err);
        }
        resolve(db);
        
      };
    });
  }
}